export default "__VITE_ASSET__CqRPm48R__"